import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const defaultState = {
  newSchool: false,
  school: null,
  role: null,
  userType: null
}

const FSUTeacherReducer = combineReducers({
  finishAsParentRequest: createRequestReducer('FSU_TEACHER:FINISH_AS_PARENT'),
  schoolSearchRequest: createRequestReducer('FSU_TEACHER:SEARCH_SCHOOL'),
  state: createReducer(defaultState, {
    'FSU_TEACHER:SET_SCHOOL': (state, { data }) => ({
      ...state,
      school: data
    }),
    'FSU_TEACHER:SHOW_NEW_SCHOOL': state => ({
      ...state,
      newSchool: true,
      school: null
    }),
    'FSU_TEACHER:CLEAR_STATE': state => ({
      ...defaultState
    }),
    'FSU_TEACHER:SET_USER_TYPE': (state, { userType }) => ({
      ...state,
      userType
    }),
    'FSU_TEACHER:SEARCH_SCHOOL_REQUEST': state => ({
      ...state,
      school: null
    })
  }),
  schools: createReducer(
    { result: null, searchValue: '' },
    {
      'FSU_TEACHER:SEARCH_SCHOOL_REQUEST': (state, { params }) => ({
        ...state,
        searchValue: params.value
      }),
      'FSU_TEACHER:CLEAR_STATE': state => ({
        result: null,
        searchValue: ''
      }),
      'FSU_TEACHER:SEARCH_SCHOOL_REQUEST_SUCCESS': (
        state,
        { params, response }
      ) => ({
        searchValue: params.value,
        result: response.data.schools
      })
    }
  )
})

export default FSUTeacherReducer
